import { Component, Inject, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {}

@Component({
  selector: "unit-status-dialog",
  templateUrl: "unit-status-dialog.html",
})
export class UnitStatusDialog implements AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<UnitStatusDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {}

  ngAfterViewInit() {}
}
